import { render, staticRenderFns } from "./magic_link.vue?vue&type=template&id=6dc42ed8&scoped=true&"
import script from "./magic_link.vue?vue&type=script&lang=js&"
export * from "./magic_link.vue?vue&type=script&lang=js&"
import style0 from "./magic_link.vue?vue&type=style&index=0&id=6dc42ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc42ed8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MagicTopbar: require('/opt/build/repo/components/magic/magic-topbar.vue').default,MagicSidebar: require('/opt/build/repo/components/magic/magic-sidebar.vue').default,Footer: require('/opt/build/repo/components/Footer.vue').default,RightSidebar: require('/opt/build/repo/components/Right-sidebar.vue').default})
